import { MapPin } from 'lucide-react';
import { NearbyAmenities } from '@/components/property-detail/NearbyAmenities';

interface ProjectLocationProps {
  city: string;
  subCity?: string | null;
  address?: string | null;
  latitude?: number | null;
  longitude?: number | null;
}

export function ProjectLocation({ city, subCity, address, latitude, longitude }: ProjectLocationProps) {
  const hasCoords = latitude != null && longitude != null;

  return (
    <section className="max-w-full overflow-hidden space-y-6">
      <div>
        <h2 className="font-display text-lg md:text-xl font-bold mb-3 md:mb-4">Location</h2>
        <div className="space-y-3">
          {hasCoords ? (
            <div className="aspect-[16/9] w-full max-w-full rounded-xl overflow-hidden border">
              <iframe
                title="Project Location"
                width="100%"
                height="100%"
                style={{ border: 0 }}
                loading="lazy"
                src={`https://www.openstreetmap.org/export/embed.html?bbox=${longitude! - 0.01},${latitude! - 0.01},${longitude! + 0.01},${latitude! + 0.01}&layer=mapnik&marker=${latitude},${longitude}`}
              />
            </div>
          ) : (
            <div className="border rounded-xl p-4 md:p-6">
              <div className="flex items-start gap-3">
                <MapPin className="h-5 w-5 text-primary mt-0.5 shrink-0" />
                <div className="min-w-0 flex-1">
                  <div className="font-semibold text-sm break-words">{city}{subCity ? `, ${subCity}` : ''}</div>
                  {address && <div className="text-sm text-muted-foreground break-words">{address}</div>}
                </div>
              </div>
            </div>
          )}
        </div>
      </div>

      <NearbyAmenities latitude={latitude} longitude={longitude} />
    </section>
  );
}
